// Share only pending reads. Settled responses are never cached, so explicit
// refreshes and mapping edits always read fresh data. Include user and scope in
// the caller's key; each caller still controls whether its result is current.
export function createInFlightRequestCache() {
  const pending = new Map<string, Promise<unknown>>();
  return function run<T>(key: string, load: () => Promise<T>): Promise<T> {
    const existing = pending.get(key);
    if (existing) return existing as Promise<T>;
    const request = Promise.resolve().then(load);
    pending.set(key, request);
    const clear = () => {
      if (pending.get(key) === request) pending.delete(key);
    };
    request.then(clear, clear);
    return request;
  };
}
